<template>
  <div id="app">
    <WordEntryInput/>

    <div v-if="hasAnyExtensions">
      <div class="extension"
        v-for="(extension, i) in extensions"
        v-if="extension.length"
        :key="i">
        <div class="extension-header">+{{i + 1}} letter{{i >= 1 ? 's' : ''}}
          <span class="count">({{extension.length}})</span>
        </div>
        <div class="word"
          v-for="word in extension"
          :key="word"
          @click="clickWord(word)"
          v-html="decorateWord(word)"
        ></div>
      </div>
    </div>
    <template v-if="!hasAnyExtensions">
      <div v-if="hasRunSearch" class="sorry">
        No extensions found
      </div>
      <div v-else>
        <WelcomeContent />
      </div>
    </template>

    <div class="debug" v-if="debug">
      <p v-if="!loadDictionaryTime">Loading dictionary... {{loadedPercent}}%</p>
    </div>
  </div>
</template>

<script>
import WelcomeContent from './components/WelcomeContent';
import WordEntryInput from './components/WordEntryInput';
import { getLetterCounts } from './store/dict';

export default {
  name: 'App',
  components: {
    WelcomeContent,
    WordEntryInput,
  },
  data() {
    return {
      debug: true,
    };
  },
  computed: {
    hasRunSearch() {
      return this.$store.state.hasRunSearch;
    },

    currentWord() {
      return this.$store.state.word;
    },

    extensions() {
      return this.$store.state.extensions;
    },

    hasAnyExtensions() {
      return this.extensions.some(extension => extension.length);
    },

    loadedPercent() {
      return this.$store.state.loadedPercent;
    },

    loadDictionaryTime() {
      return this.$store.getters.loadDictionaryTime;
    },
  },
  methods: {
    clickWord(word) {
      this.$store.dispatch('findExtensionWords', word);
    },
    decorateWord(word) {
      const currentWordCounts = getLetterCounts(this.currentWord);
      let html = '';
      word.split('').forEach((letter) => {
        if (currentWordCounts[letter] > 0) {
          html += letter;
        } else {
          html += `<span class='delta'>${letter}</span>`;
        }
        currentWordCounts[letter] -= 1;
      });
      return html;
    },
  },
};
</script>

<style>
#app {
  font-family: 'Work Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.extension-header {
  font-weight: bold;
  font-size: 22px;
  margin: 16px 0;
}

.word {
  padding: 6px 0;
  font-size: 18px;
}

.sorry {
  color: #ccc;
  margin: 16px 0;
}

.debug {
  color: #ccc;
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
}

span.delta {
  background: #f6f6f6;
  border-bottom: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue